module.exports = __webpack_public_path__ + "img/default.e9b8fdf4.png";